import LoadingButton from './LoadingButton'

export default LoadingButton
